<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Customers'"
        :buttons="[
          {
            title: 'Send Update Users',
            icon: 'fa fa-sync',
            emit: 'sendUpdateUsers',
            class: 'btn-danger',
          },
          {
            title: 'Reload',
            icon: 'fa fa-sync',
            emit: 'reload',
          },
          {
            title: 'Add Customer',
            icon: 'fa fa-plus',
            emit: 'add',
          },
        ]"
        @add="addShow = true"
        @reload="get()"
        @sendUpdateUsers="sendUpdateUsers()"
      ></cardHead>

      <Form
        method="dialog"
        v-slot="{ errors }"
        class="financeType floating-labels p-1rem row align-items-center"
        ref="form"
      >
        <div class="col">
          <formGroup
            title="Info Type"
            :as="'select'"
            :errors="errors"
            v-model="tableTypeModel"
          >
            <template #input>
              <option value="general">General Info</option>
              <option value="financial">Financial Info</option>
            </template>
          </formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Pasifleri Göster'"
            :as="'checkbox'"
            v-model="isShowPassive"
          ></formGroup>
        </div>
      </Form>
      <dataTable
        :name="'Customers'"
        :key="tableTypeModel"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="
          data == null
            ? null
            : data.filter((x) => {
                return isShowPassive ? true : x.Active;
              })
        "
        @cellClicked="detailShow = { ...$event.data }"
        :addContextMenuItem="getContextMenuItems"
        :rowClassRules="{
          // row style function
          warning: (params) => {
            // var numSickDays = params.data;
            return (
              params?.data?.minEndDate < 31 && params?.data?.minEndDate > 15
            );
          },
          danger: (params) => {
            // var numSickDays = params.data;
            return params?.data?.minEndDate < 16;
          },
        }"
      ></dataTable>
      <add
        v-if="addShow"
        @add="$refs.agGrid.addRow([$event])"
        @close="addShow = false"
      ></add>
      <detail
        v-if="detailShow != null"
        :setModel="detailShow"
        @update="$refs.agGrid.changeRow('Id', $event)"
        @close="detailShow = null"
      ></detail>
    </div>
  </div>
</template>

<script>
import add from "./add";
import detail from "./detail/detail";
export default {
  name: "customers",
  components: { add, detail },
  data() {
    return {
      data: null,
      addShow: false,
      detailShow: null,
      tableTypeModel: "general",
      isShowPassive: false,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin.get(`Customers`).then((response) => {
        response.data.forEach((element) => {
          if (element.ReservationCount > 0) {
            element.Diff = (
              element.ProcessedReservationCount /
              (element.ReservationCount / 100)
            ).toFixed(2);
          } else {
            element.Diff = (0).toFixed(2);
          }

          if (element.Kolayrez) {
            element.minEndDate = Math.ceil(
              (new Date(element.KolayrezEndDate).getTime() -
                new Date().getTime()) /
                (1000 * 3600 * 24)
            );
          }
          if (
            element.FlightStats &&
            element.minEndDate >
              Math.ceil(
                (new Date(element.FlightStatsEndDate).getTime() -
                  new Date().getTime()) /
                  (1000 * 3600 * 24)
              )
          ) {
            element.minEndDate = Math.ceil(
              (new Date(element.FlightStatsEndDate).getTime() -
                new Date().getTime()) /
                (1000 * 3600 * 24)
            );
          }
        });

        this.data = response.data.sort((x, y) => {
          return x.minEndDate - y.minEndDate;
        });
      });
    },
    sendUpdateUsers() {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text: "Kullanıcılara güncelleme göndermek istediğinize emin misiniz?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`Users/Refresh`)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Güncelleme gönderildi",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning!",
        text:
          "Are you sure you want to delete the customer named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Customers/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The customer has been successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Detail",
          icon: "<i class='fas fa-search'></i>",
          action: () => {
            this.detailShow = params.node.data;
          },
        },
        {
          name: "Remove",
          icon: "<i class='fas fa-trash-alt'></i>",
          action: () => {
            this.remove(params.node.data);
          },
        },
      ];
      return result;
    },
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Name",
          field: "Name",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "HotelCount",
          field: "HotelCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "RoomCount",
          field: "RoomCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "ProviderCount",
          field: "ProviderCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "CustomerProviderCount",
          field: "CustomerProviderCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "ReservationCount",
          field: "ReservationCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "MailReservationCount",
          field: "MailReservationCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "WaitReservationCount",
          field: "WaitReservationCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "ProcessedReservationCount",
          field: "ProcessedReservationCount",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "Diff",
          field: "Diff",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "general",
          headerName: "minEndDate",
          field: "minEndDate",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          sort: "asc",
          flex: 1,
          minWidth: 140,
        },

        {
          hide: this.tableTypeModel != "financial",
          headerName: "WorkingModel",
          field: "WorkingModel",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "financial",
          headerName: "MonthlyPrice",
          field: "MonthlyPrice",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "financial",
          headerName: "YearlyPrice",
          field: "YearlyPrice",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "financial",
          headerName: "HotelBasedPrice",
          field: "HotelBasedPrice",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "financial",
          headerName: "YearlyRoomBasedPrice",
          field: "YearlyRoomBasedPrice",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          hide: this.tableTypeModel != "financial",
          headerName: "MonthlyRoomBasedPrice",
          field: "MonthlyRoomBasedPrice",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agNumberColumnFilter",
          flex: 1,
          minWidth: 140,
        },

        {
          headerName: "Active",
          field: "Active",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "1. Logo",
          field: "Name1",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<img src='https://resbox.com/img/media/companys/" +
              event.data.Name +
              ".png' style='height:29px; margin-top: -2px;'/>"
            );
          },
        },
        {
          headerName: "2. Logo",
          field: "Name2",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
          cellRenderer: function(event) {
            return (
              "<img src='https://resbox.com/offer/img/hotel/" +
              event.data.Name +
              ".png' style='height:29px; margin-top: -2px;'/>"
            );
          },
        },
      ];
    },
  },
};
</script>

<style scoped>
.financeType /deep/ .form-group {
  margin-bottom: 0;
}
</style>
